/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";
const G = "#0077B5";
const GD = "#005885";
const GRN = "#1D9E75";
const CARD = "#FFFFFF";
const B = "#E1E9EE";
const RED = "#D85A30";
const RED2 = "#FEF2F2";

const SectionLabel = ({ children }) => (
  <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, letterSpacing: "0.2em", color: "#999999", textTransform: "uppercase", marginBottom: 16 }}>{children}</div>
);
const Divider = () => <div style={{ height: 1, background: B, margin: "28px 0" }} />;

function supportRef(uid) {
  if (!uid) return "—";
  return "NCT-" + (parseInt(uid) + 5000).toString(36).toUpperCase();
}

export default function AccountTab({ user }) {
  const [liConnected, setLiConnected] = useState(null);
  const [disconnectConfirm, setDisconnectConfirm] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);
  const [reconnecting, setReconnecting] = useState(false);


  useEffect(() => {
    fetch(`${API_BASE}/app/api/auth/linkedin/status?ping=1`, { credentials: "include" })
      .then(r => r.json())
      .then(d => setLiConnected(d.connected === true))
      .catch(() => setLiConnected(false));
  }, []);

  const handleDisconnect = async () => {
    setDisconnecting(true);
    try {
      await fetch(`${API_BASE}/app/api/auth/linkedin/disconnect`, { method: "POST", credentials: "include" });
      setLiConnected(false);
      setDisconnectConfirm(false);
    } catch {}
    setDisconnecting(false);
  };

  const handleReconnect = () => {
    setReconnecting(true);
    window.location.href = `${API_BASE}/app/api/auth/linkedin/connect?reconnect=1`;
  };

  return (
    <div>
      <SectionLabel>LinkedIn connection</SectionLabel>
      {liConnected === null ? (
        <div style={{ fontSize: 13, color: "#999", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", padding: "12px 0" }}>Checking connection…</div>
      ) : liConnected ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: CARD, border: `1px solid ${B}`, borderRadius: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "16px 18px", marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 36, height: 36, background: "#0077b5", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ color: "#fff", fontSize: 16, fontWeight: "bold", fontFamily: "sans-serif" }}>in</span>
            </div>
            <div>
              <div style={{ fontSize: 16, marginBottom: 2 }}>{user?.linkedin_name || "Connected"}</div>
              <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, color: GRN }}>● Connected</div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: CARD, border: `1px solid ${B}`, borderRadius: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "16px 18px", marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 36, height: 36, background: "#E1E9EE", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ color: "#999", fontSize: 16, fontWeight: "bold", fontFamily: "sans-serif" }}>in</span>
            </div>
            <div>
              <div style={{ fontSize: 16, color: "#666666", marginBottom: 2 }}>Not connected</div>
              <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, color: "#999999" }}>○ Connect LinkedIn to start posting.</div>
            </div>
          </div>
          <button onClick={handleReconnect} disabled={reconnecting} style={{ background: G, color: "#fff", border: "none", borderRadius: 6, padding: "8px 16px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "pointer", minHeight: 44, opacity: reconnecting ? 0.6 : 1 }}>{reconnecting ? "Loading…" : "Reconnect →"}</button>
        </div>
      )}

      <Divider />
      <SectionLabel>Export data</SectionLabel>
      <div style={{ fontSize: 14, color: "#666", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", marginBottom: 16, lineHeight: 1.6 }}>
        Download a copy of all your posted content and settings.
      </div>
      <button style={{ background: "transparent", color: "#666666", border: `1px solid ${B}`, borderRadius: 8, padding: "10px 22px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "not-allowed", minHeight: 44, opacity: 0.5 }}>
        Export data (coming soon)
      </button>

      <Divider />
      <SectionLabel>Support</SectionLabel>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 28 }}>
        <a href="mailto:operator@bhive.ca" style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 16px", background: CARD, border: `1px solid ${B}`, borderRadius: 9, cursor: "pointer", textDecoration: "none", color: "inherit" }}>
          <span style={{ fontSize: 20 }}>📧</span>
          <div>
            <div style={{ fontSize: 16, marginBottom: 2 }}>Email support</div>
            <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, color: GD }}>operator@bhive.ca</div>
          </div>
        </a>
      </div>

      <Divider />
      <SectionLabel>Danger zone</SectionLabel>
      <div style={{ background: RED2, border: "1px solid #FECDD3", borderRadius: 12, padding: "20px", display: "flex", flexDirection: "column", gap: 20 }}>
        {/* Disconnect LinkedIn */}
        {liConnected && !disconnectConfirm && (
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#B91C1C", marginBottom: 4 }}>Disconnect LinkedIn</div>
            <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, color: "#666", lineHeight: 1.6, marginBottom: 10 }}>
              All scheduled posts will be paused immediately. You'll need to reconnect to resume posting.
            </div>
            <button onClick={() => setDisconnectConfirm(true)} style={{ background: "transparent", color: "#dc3545", border: "1px solid #dc354544", borderRadius: 6, padding: "8px 18px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "pointer", minHeight: 44 }}>
              Disconnect LinkedIn
            </button>
          </div>
        )}
        {disconnectConfirm && (
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#B91C1C", marginBottom: 6 }}>Are you sure you want to disconnect?</div>
            <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, color: "#B91C1C", lineHeight: 1.6, marginBottom: 12 }}>
              This will immediately pause all your scheduled posts. Your content will be saved, but nothing will be published until you reconnect LinkedIn.
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setDisconnectConfirm(false)} style={{ background: "#fff", color: "#666666", border: `1px solid ${B}`, borderRadius: 6, padding: "7px 16px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "pointer", minHeight: 44 }}>Cancel</button>
              <button onClick={handleDisconnect} disabled={disconnecting} style={{ background: "#dc3545", color: "#fff", border: "none", borderRadius: 6, padding: "7px 16px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "pointer", minHeight: 44, opacity: disconnecting ? 0.6 : 1 }}>{disconnecting ? "Disconnecting…" : "Yes, disconnect"}</button>
            </div>
          </div>
        )}

        {/* Cancel / billing management */}
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#B91C1C", marginBottom: 4 }}>Cancel subscription</div>
          <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, color: "#666", lineHeight: 1.6 }}>
            To cancel, downgrade, or delete your account, scroll up to the <strong>Billing</strong> section.
          </div>
        </div>
      </div>
    </div>
  );
}
